/**
 * Time to Dom interactive
 * This is the time when the browser finished parsing the html.
 * https://varvy.com/pagespeed/critical-render-path.html
 */
import { simpleMetricFactory } from './simpleMetricFactory';
// By the time this runs the fetchStart is guaranteed to have a value, we check to see which type of perf entry we could get by
// figuring out if the value is a DOMHighResTimestamp (lvl2) or a regular timestamp (lvl1).
export function calculateTTDI(navEntry) {
    if (navEntry.domInteractive > 0) { // This one is required for both
        // Nav timing api lvl 1.
        if (navEntry.fetchStart > 0 && (navEntry.fetchStart % 1 === 0))
            return navEntry.domInteractive - navEntry.fetchStart;
        // Nav timing api lvl 2
        return navEntry.domInteractive;
    }
    return false;
}
export var getTTDI = simpleMetricFactory('time.to.dom.interactive', calculateTTDI);
